// extracted by mini-css-extract-plugin
module.exports = {"container":"universal-container_container__LQ_Pe"};